import JxTooltip from '../../../../../JxControls/JxTooltips/JxTooltip.jsx';

import rkLinkifier from '../RkLinkifier';
import './IndexBlock.css';

/**
 * Renders a parsed "Name | RK | Description" index table as a proper table with a
 * clickable RK column - companion to SourceTreeBlock, same box styling language.
 * @param {object} props
 * @param {Array} props.rows - rows from indexBlockParser.parseIndexBlock
 */
export default function IndexBlock({ rows }) {
    /**
     * Navigates to the note behind this row's RK.
     * @param {string} rk
     */
    function handleRkClick(rk) {
        rkLinkifier.navigateTo(rk);
    }

    return (
        <div className="idxb-block">
            {rows.map((row, i) => {
                if (row.kind === 'header') {
                    return (
                        <div className="idxb-headerrow" key={i}>
                            <div className="idxb-h idxb-h-name">Naam</div>
                            <div className="idxb-h idxb-h-rk">RK</div>
                            <div className="idxb-h idxb-h-desc">Description</div>
                        </div>
                    );
                }
                if (row.kind === 'raw') {
                    return <div className="idxb-raw" key={i}>{row.raw}</div>;
                }
                return (
                    <div className="idxb-row" key={i}>
                        <div className="idxb-name">{row.name}</div>
                        <JxTooltip title="Go to this note" placement="top">
                            <div className="idxb-rk" onClick={() => handleRkClick(row.rk)}>
                                {row.rk}
                            </div>
                        </JxTooltip>
                        <div className={`idxb-desc ${row.desc ? '' : 'idxb-desc-empty'}`}>{row.desc}</div>
                    </div>
                );
            })}
        </div>
    );
}
